'use strict';

class Cart {
  $onInit() {
    this.items = [];
  }

  /**
   * Calculate sum of the items in the cart
   *
   * @returns {Number} Sum of items in the cart
   */
  calc() {
    let total = 0;

    if (this.items.length) {
      this.items.forEach((i) => {
        total += parseFloat(i.price, 10);
      });
    }

    return total;
  }
}

const cart = {
  bindings: {
    items: '<'
  },
  controller: Cart,
  template: `
    <ul class="pricing-table">
      <li class="title">Pris eks. MVA</li>
      <li class="bullet-item" ng-repeat="item in $ctrl.items track by $index">
<!--          <span ng-show="item.name === 'Administrasjonsgebyr'" data-balloon="Administrasjonsgebyret legges til én gang i måneden. Det vil ikke bli lagt til dersom dette er den første, gratis regningen som sendes med SendRegning.">-->
<!--            <i class="fa fa-question-circle"></i>-->
<!--          </span>-->
        {{ item.name }}
        <b>{{ item.price | crowns }}</b>
      </li>
      <li class="price">Totalt <b>{{ $ctrl.calc() | crowns }}</b></li>
    </ul>
  `
};

angular
  .module('SendRegning')
  .component('cart', cart);
